import React from 'react';
import {Link} from 'react-router-dom';

import {FORGOTTEN_PASSWORD_URL, SUPPORT_EMAIL} from 'paths';

export default function UnableToLogin() {
    return <div>
        <h3>Unable to login?</h3>
        <p>
            You can <Link to={FORGOTTEN_PASSWORD_URL}>reset your password</Link> or, for additional support,
            contact <Link to={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
        </p>
    </div>;
}